import React, { useEffect, useRef } from 'react';
import { Body, Box, Select } from '@hover/blueprint';
import {
  Controller,
  Control,
  RegisterOptions,
  useWatch,
} from 'react-hook-form';
import { IJobQuestion } from '../../../interfaces/IJobQuestion';

interface Props {
  control: Control;
  jobQuestion: IJobQuestion;
  errorMessage: string | undefined;
  rules: RegisterOptions;
  required: boolean;
}

const MultiValueSingleSelect: React.FC<Props> = ({
  control,
  jobQuestion,
  errorMessage,
  required,
  rules,
}) => {
  const ref = useRef<HTMLSelectElement>(null);

  const currentValue = useWatch({
    control,
    name: jobQuestion.fields[0].name,
  }) as number;

  useEffect(() => {
    if (!currentValue && ref.current) {
      ref.current.value = '';
    }
  }, [currentValue]);

  return (
    <Box flexDir="column" mb="30px">
      <Body mb={100}>
        {jobQuestion.label}
        {required && '*'}
      </Body>
      <Controller
        rules={rules}
        name={jobQuestion.fields[0].name}
        control={control}
        render={({ field: { onChange, value } }) => (
          <Select
            ref={ref}
            textColor={errorMessage ? 'orange.500' : 'neutral.700'}
            borderColor={errorMessage ? 'orange.500' : 'neutral.300'}
            onChange={({ target }) => onChange(target.value)}
            value={value as string}
            placeholder={required ? 'PLEASE SELECT *' : 'PLEASE SELECT'}
          >
            {jobQuestion.fields[0].values.map(fieldValues => (
              <option value={fieldValues.value} key={fieldValues.value}>
                {fieldValues.label}
              </option>
            ))}
          </Select>
        )}
      />
      {!!errorMessage && (
        <Body isSemiBold mt={200} ml={200} size={300} color="danger.300">
          {errorMessage}
        </Body>
      )}
    </Box>
  );
};

export default MultiValueSingleSelect;
